import React, { useEffect, useRef } from 'react';
import Logo from '@/components/icons/Logo';

interface GradientSweepProps {
  onFinish?: () => void;
}

const GradientSweep: React.FC<GradientSweepProps> = ({ onFinish = () => null }) => {
  const gradientRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (gradientRef.current && containerRef.current) {
      containerRef.current.style.opacity = '1';

      const animation = gradientRef.current.animate(
        [
          { opacity: 0, transform: 'translate(-50%, -50%) rotate(0deg)' },
          { opacity: 0.75, transform: 'translate(-50%, -50%) rotate(360deg)' },
          { opacity: 1, transform: 'translate(-50%, -50%) rotate(720deg)' },
          { opacity: 0.75, transform: 'translate(-50%, -50%) rotate(1080deg)' },
          { opacity: 0, transform: 'translate(-50%, -50%) rotate(1440deg)' },
        ],
        {
          duration: 1250,
          easing: 'linear',
        }
      );

      animation.onfinish = () => {
        onFinish();
        if (containerRef.current) {
          containerRef.current.style.opacity = '0';
        }
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
      }}
    >
      <div
        ref={gradientRef}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '220%',
          height: '220%',
          transform: 'translate(-50%, -50%)',
          transformOrigin: 'center center',
          background: 'linear-gradient(to top right, red, yellow, blue)',
          opacity: 0,
        }}
        className={'flex items-center justify-center'}
      >
        <Logo style={{ width: 1000, height: 'auto' }} />
      </div>
    </div>
  );
};

export default GradientSweep;
